/* Product Tabs */
  $(document).ready(function() {
   
    const urlParams = new URLSearchParams(window.location.search);
    const hasInstallParam = urlParams?urlParams.has('installation'):false;

    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      var activeLink;
      
      links.each(function () {
          if (!activeLink || (hasInstallParam && this.textContent.trim() === "Installation")){
            console.log(`Found Installation Anchor ${this}`); 
            activeLink = this;
          }
      });
      
      active = $(activeLink).addClass('active');
      content = $(active.attr('href'));

      console.log(`Active Link ${activeLink}`); 
      links.each(function () {
        console.log(`Current ${this}`); 
        if (this!=activeLink){
            console.log(`Hiding ${this}`); 
          //  $($(this).attr('href')).hide();
          // Instead of .hide(), we add a class
          $($(this).attr('href')).addClass('hidden-tab');
        }
      });

      $(this).find('a').click(function(e){
        active.removeClass('active');
        // Swap classes instead of using .hide()
      content.addClass('hidden-tab');

        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.removeClass('hidden-tab');
      
      // Trigger a window resize to tell YouTube to check its new width
      window.dispatchEvent(new Event('resize'));
        return false;
      });
    });
  });
/* End Product Tabs */